import { render, staticRenderFns } from "./customerDeposit.vue?vue&type=template&id=38f1feb6&scoped=true"
import script from "./customerDeposit.vue?vue&type=script&lang=js"
export * from "./customerDeposit.vue?vue&type=script&lang=js"
import style0 from "./customerDeposit.vue?vue&type=style&index=0&id=38f1feb6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38f1feb6",
  null
  
)

export default component.exports